function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function isIE() {
  return !!document.documentMode || navigator.appName == 'Microsite Internet Explorer';
}

/**
 * event_tracker
 * Fires either Google Tag Manager or Google Analytics events
 *
 **/
function event_tracker(category, action, label, value) {
  action = action ? action : 'click';

  if (typeof gtag == 'function') {
    var data = {
      'event_category' : category,
      'event_label' : label,
      'value' : value
    };
    gtag('event', action, data);
  }
  else if (typeof ga == 'function') {
    ga('send', 'event', category, action, label, value);
  }
}


// -- Custom jQuery function to get a cached version of a script
var getCachedScript = function(url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend( options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax( options );
};


// -- Get URL Parameter function
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      sParameterName[1] = sParameterName[1].replace('+',' ');
      return decodeURIComponent(sParameterName[1]);
    }
  }
}

/**
 * Defer loading css styles until after page load
 */
var loadDeferredStyles = function() {
  var addStylesNode = document.getElementById("deferred-styles");
  if (addStylesNode != null) {
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
  }
};

var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

if (raf) raf(function() { window.setTimeout(loadDeferredStyles, 0); });
else window.addEventListener('load', loadDeferredStyles);


var htmlOverflow = function(element) {
  if (element.is(':visible')) {
    $('html').css('overflow','hidden');
  }
  else {
    $('html').css('overflow','');
  }
};


// -- Used for IE to replace btoa function
function encode64(input) {
  var keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
  input = encodeURI(input);
  var output = "";
  var chr1, chr2, chr3 = "";
  var enc1, enc2, enc3, enc4 = "";
  var i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
       enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
       enc4 = 64;
    }

    output = output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = "";
    enc1 = enc2 = enc3 = enc4 = "";
  } while (i < input.length);

  return output;
}


function alertMessage($type, $message) {
  var $alert = $('#alert');
  if ($alert.length) {
    $alert.addClass('alert--' + $type).text($message).slideDown();
    setTimeout(function() {
      $alert.slideUp(function() {
        $alert.removeClass('alert--' + $type).text('');
      });
    }, 3000);
  }
}

// ----------------------------------------------------------------------------
//  scriptLoader
// ----------------------------------------------------------------------------
function scriptLoader(deferredScripts) {
  $(window).load(function(){
    setTimeout(function(){
      if (deferredScripts && typeof $ != 'undefined') {
        if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
          $('head').find('meta[charset]').after(deferredScripts.head.join(''));
        }

        if (deferredScripts.head_close && Array.isArray(deferredScripts.head_close) && deferredScripts.head_close.length) {
          $('head').append(deferredScripts.head_close.join(''));
        }

        if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
          $('body').prepend(deferredScripts.body.join(''));
        }

        if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
          $('body').append(deferredScripts.footer.join(''));
        }
      }
    }, 1200);
  });
}

// ----------------------------------------------------------------------------
//  Google Conversion
// ----------------------------------------------------------------------------
function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}

(function($){
  'use strict';

  var aboutUs = {
    dom: function() {
      this.$toggle = $('[data-js-hook="amenity-toggle"]');
      this.$content = $('.tab-content');
    },

    toggle: function() {
      var self = this;

      // var title = $(document).find('title').text();

      this.$toggle.click(function(e){
        e.preventDefault();
        var target = $(this).data('target');
        var newUrl = '/about-us/?amenity=' + target;

        self.$content.removeClass('active');
        $('.tab-content.' + target).addClass('active');
        self.$toggle.removeClass('active');
        $(this).addClass('active');

        // -- Update browser address bar & title
        if (typeof (history.pushState) != "undefined") {
          window.history.pushState(null, null, newUrl);
        } else {
          document.location.href = newUrl;
        }
      });
    },

    ready: function() {
      this.dom();
      this.toggle();
    }
  };

  $(document).ready(aboutUs.ready());

})(jQuery);

(function($) {
  'use strict';

  var amenities = {
    dom: function() {
      this.$toggleAmenity = $('#toggle-amenity');
      this.$toggleAmenityGroup = $('[data-js-hook="toggle-amenity-group"]');
      this.$hiddenAmenity = $('[data-js-hook="hidden-amenity"]');
      this.$tabs = $('[data-js-hook="amenityTabs"]');
      this.$active = $('#amenityActive');
    },

    tabs: function() {
      var main = this;

      function showHide(element) {
        var $target = $('[data-target="' + element + '"]');
        if (!$target.length) {
          return;
        }

        $('.amenity-c__group').hide();
        main.$tabs.children().removeClass('active');
        $target.addClass('active');
        $('#' + element).show();
        main.$active.text($target.text());

        if ($('#amenityTabs').length) {
          $('html, body').animate({
            scrollTop: $('#amenityTabs').offset().top
          });
        }
        
        $('#' + element).children().css({
          visibility: 'visible',
        });
      }

      this.$active.click(function() {
        main.$tabs.slideToggle();
      });

      if (window.location.hash) {
        var target = window.location.hash.replace('#','');
        showHide(target);
      }

      this.$tabs.children().click(function(event) {
        event.preventDefault();
        var target = $(this).data('target');
        window.location.hash = target;
        showHide(target);

        if ($(window).width() <= config.mobileBreak) {
          main.$tabs.slideToggle();
        }
      });
    },

    toggleAmenities: function() {
      var self = this;

      this.$toggleAmenityGroup.click(function(e){
        e.preventDefault();
        var $hiddenAmenities = self.$hiddenAmenity.filter('[data-amenity-group=' + $(this).data('amenity-group') + ']');
        var $this = $(this);
        $(this).toggleClass('amenity-a__expand--expanded');
        $hiddenAmenities.slideToggle(200, function(){
          var visible = $hiddenAmenities.first().is(':visible');
          $this.find('[data-js-hook="expand-icon"]').html(visible ? '&times;' : '+');
          $this.find('[data-js-hook="expand-verbiage"]').html(visible ? 'Show Less' : 'Show More');
        });
      });

      this.$toggleAmenity.click(function(e){
        e.preventDefault();
        var $this = $(this);
        self.$hiddenAmenity.slideToggle(200, function(){
          var visible = self.$hiddenAmenity.first().is(':visible');
          $this.text(visible ? 'Show Less' : 'Show More');
        });
      });
    },

    ready: function() {
      this.dom();
      this.tabs();
      this.toggleAmenities();
    }
  };

  $(function(){
    amenities.ready();
  });

})(jQuery);

(function(){

	var apply = {
		domCache: function() {
			// -- Form
			this.$file 		   		= $('#file');
			this.$fileName  		= $('#file-name-preview');
			this.$fileToggle 		= $('#file-toggle');
			this.$applyForm  		= $('#apply-form');

			// -- Job Single View
			this.$applyFormWrap = $('#apply-form-wrap');
			this.$showApplyForm = $('#show-apply-form');
		},

		file: function() {
			var self = this;

			this.$file.change(function(){
				var filename = $(this).val().split(/(\\|\/)/g).pop();
				self.$fileName.html(filename).slideDown(100);
			});

			this.$fileToggle.click(function(e){
				e.preventDefault();
				self.$file.trigger('click');
			});
		},

		applyForm: function() {
			var self = this;

			this.$applyForm.formulate({
		    require: 'First Name, Last Name, Email{email}, Resume',
		    errorClass: 'form__field--error',
		    showOnSubmit: '',
		    ajax: false,
		    fireOnError: function(data) {
			  	$(document).find('.form__field--error').siblings('[data-infield-label]').addClass('form__label--error');
					if (self.$file.hasClass('form__field--error')) {
						$('.form__row--file').addClass('form__row--error');
					} else {
						$('.form__row--file').removeClass('form__row--error');
					}
				}
			});
		},

		toggleForm: function() {
			var self = this;
			this.$showApplyForm.click(function(e){
				e.preventDefault();
				self.$applyFormWrap.slideToggle(200);
			});
		},

		init: function() {
			this.domCache();
			this.file();
			this.applyForm();
			this.toggleForm();
		}
	}

	$(document).ready(apply.init());

})();

(function($) {
  'use strict';

  var property = {

    dom: function() {
      this.petPolicy = {
        $button: $('#pet-policy'),
        $flyout: $('#pet-policy-flyout')
      };

      this.$rotator = $('#rotator');
      this.$video = $('#homeVideo');
    },


    definitions: function() {

      var videoLoopLimit = 3;
    },

    
    execPetPolicy: function() {
      var self = this;
      var policyCloserTimeout;

      this.petPolicy.$flyout.mouseenter(function(){
        clearTimeout(policyCloserTimeout);
      }).mouseleave(function(){
        self.petPolicy.$button.removeClass('header__toolbar-contact-content--active-pet');
        self.petPolicy.$flyout.fadeOut(100);
      });

      this.petPolicy.$button.click(function(e){
        e.preventDefault();
        $(this).addClass('header__toolbar-contact-content--active-pet');
        self.petPolicy.$flyout.fadeToggle(100);
      }).mouseleave(function(e){
        var $this  = $(this);

        policyCloserTimeout = setTimeout(function(){
          $this.removeClass('header__toolbar-contact-content--active-pet');
          self.petPolicy.$flyout.fadeOut(100);
        }, 30);
      });
    },

    // Handle rotator functionality
    rotator: function() {
      var self = this;
      var debug = window.location.search.match(/debug-video=1/);

      if ($('#homeVideo').length === 0) { // Check if there is no video
        var flexsliderOptions = {
          controlNav: true,
          directionNav: true,
          selector: 'ul > li'
        };

        this.$rotator.find('.property-landing__rotator-slides').flexslider(flexsliderOptions);

        this.$rotator.find('.flex-direction-nav, .flex-nav-prev, .flex-nav-next').show();
      } else {
        // Hide the rotator slides and navigation elements
        this.$rotator.find('.property-landing__rotator-slides, .flex-direction-nav, .flex-nav-prev, .flex-nav-next').hide();

        if (this.$video.length) {
          var loop = 0;
          var video = this.$video.get(0);

          $('.flex-direction-nav').hide();

          if (debug) {
            $('.property-landing-page__rotator-color-overlay').hide();
            $('.property-landing-page__rotator-dimmer').hide();
            $('.property-landing-page__rotator-content').hide();
            this.$video.attr('controls', true);
          }

          if (videoLoopLimit != '' && videoLoopLimit != null) {
            this.$video.removeAttr('loop');

            if (videoLoopLimit == 'auto') {
              video.onloadedmetadata = function() {
                var duration = Math.floor(this.duration);
                videoLoopLimit = duration > 180 ? 1 : Math.floor(180 / duration);

                if (debug) {
                  console.log('Video loop limit (auto): ' + videoLoopLimit);
                }
              };
            } else {
              videoLoopLimit = parseInt(videoLoopLimit);

              if (debug) {
                console.log('Video loop limit (explicit): ' + videoLoopLimit);
              }
            }

            video.addEventListener('ended', function(){
              if (loop < videoLoopLimit) {
                if (debug) {
                  console.log('video looped');
                }

                this.currentTime = 0;
                this.play();
                ++loop;
              } else {
                // Show the rotator slides and navigation elements
                self.$rotator.find('.property-landing__rotator-slides, .prp').show();
                self.$rotator.find('.flex-direction-nav, .flex-nav-prev, .flex-nav-next').show();

                // Hide the video
                $('#homeVideo').hide();

                // Reset the video or fallback to rotator
                if (self.$video.data('fallback-to-rotator') === 1) {
                  self.$video.hide();

                  if (self.$rotator.length) {
                    self.$rotator.trigger('set-image-height');
                  }
                } else {
                  video.src = '';
                }

                if (debug) {
                  console.log('video loop limit reached');
                }
              }
            });
          } else if (debug) {
            console.log('Video loop limit: none');
          }
        }
      }
    },

    ready: function() {
      this.dom();
      this.definitions();
      this.execPetPolicy();
      this.rotator();
    }
  };

  $(function(){
    // Hide FlexSlider navigation items immediately upon page load
    $('#rotator .flex-direction-nav, #rotator .flex-nav-prev, #rotator .flex-nav-next').hide();

    // Call the ready function
    property.ready();
  });

})(jQuery);

// if ($('#map_canvas').length) {
//   var infowindow;
//   var gMap; //Google map object
//   var sBasePath = '';
//   var openWindow; //Used to track which Google InfoWindow is currently open
//   var aMarkers = []; //Array of all the visible markers
//   var infoClose = ""; //infoWindow close icon
//   var closePosition = "0";
//   var bGoogleLibraryLoaded = false;


//   $(document).ready(function () {
//     sBasePath = $('#map_canvas').attr('data-base-url');

//     // Don't run anything at all until Google code has loaded
//         loadMap();
//   });

//   /**
//    *
//    * @returns {undefined}
//    */
//   function loadMap() {
//     //don't attempt until after Google Library is loaded
//     if (bGoogleLibraryLoaded == false) return true;

//     //set the config options for the map
//     var myOptions = getMapOptions();

//     //create the map
//     gMap = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

//     //add the map controls (zoom, pan, etc)
//     var elMapControlDiv = document.createElement('div');
//     gMap.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(elMapControlDiv);

//     google.maps.event.addDomListener(window, 'resize', loadMap);
//     google.maps.event.addDomListener(window, 'load', loadMap);

//     //Add all communities pointer markers to the map, center and zoom to appropriate level
//     fillMap();
//   }

//   /**
//    * Go through each of the communities listed and add a marker on the map
//    * for each one of them.
//    *
//    * @returns {undefined}
//    */
//   function fillMap() {
//     var jMarker;
//     var oDetails;

//     //pinpoint all the visible communities
//     $('[data-js-hook="marker"]:visible').each(function(index) {
//       jMarker = $(this);

//       //add a map point for this community
//       oDetails = {
//         'id':jMarker.data('id'),
//         'lat':jMarker.data('lat'),
//         'lng':jMarker.data('lng'),
//         'name':jMarker.data('name')
//       };
//       addMarkerToMap(oDetails);
//     });

//     //center the map and zoom so all markers are visible
//     var gBoundary = new google.maps.LatLngBounds();
//     for (iIndex in aMarkers) {
//       position = aMarkers[iIndex].position;
//       gBoundary.extend(position);
//     }
//     gMap.fitBounds(gBoundary);
//     if (aMarkers.length === 1) {
//       gMap.setZoom(gMap.getZoom() - 8);
//     } else {
//       gMap.setZoom(gMap.getZoom() - 1);
//     }
//   }

//   /**
//    * Clear all markers off the map and then add back
//    * markers for the listed communities.
//    *
//    * @returns {undefined}
//    */
//   function resetMap() {
//     var gMarker;

//     if (openWindow) {
//       openWindow.close();
//     }

//     while (aMarkers.length > 0) {
//       gMarker = aMarkers.pop();
//       //remove the marker off the map
//       gMarker.setMap(null);
//       gMarker = null;
//     }

//     //add filtered markers back to the map
//     loadMap();
//   }


//   //The search for venue tweets has to do something slightly different to manipulate the google InfoWindow
//   function showMarkerInfoWindow(oInfoWindow, oMarker) {
//     //Open up the window!
//     oInfoWindow.open(gMap, oMarker);
//     openWindow = oInfoWindow;
//   }

//   /**
//    * Add one marker to the map.
//    *
//    * @param {type} oDetails
//    * @returns {undefined}
//    */
//   function addMarkerToMap(oDetails) {
//     var oMarkerLatLng = new google.maps.LatLng(oDetails.lat, oDetails.lng);

//     //Use InfoBox extension instead of InfoWindow so we can style
//     var oInfoBoxOptions = {
//       content: $('#tooltip-' + oDetails.id).html(),
//       disableAutoPan: false,
//       alignBottom: true,
//       maxWidth: 0,
//       pixelOffset: new google.maps.Size(0, -30),
//       zIndex: null,
//       boxClass: "infoBox",
//       closeBoxURL: infoClose,
//       closeBoxMargin: closePosition,
//       infoBoxClearance: new google.maps.Size(1, 1),
//       isHidden: false,
//       pane: "floatPane",
//       enableEventPropagation: true
//     };
//     var infowindow = new InfoBox(oInfoBoxOptions);
//     var pointerIcon = sBasePath + 'map-red.png';
//     var gMarker = new google.maps.Marker({
//       position: oMarkerLatLng,
//       icon: pointerIcon,
//       map: gMap
//     });

//     gMarker.setVisible(true);
//     aMarkers.push(gMarker);

//     //Setup CLICK handler for the marker - to open the InfoWindow for this marker
//     google.maps.event.addListener(gMarker, 'click', function () {
//       if (openWindow) {
//         openWindow.close();
//       }
//       showMarkerInfoWindow(infowindow, gMarker);
//       gMap.panTo(gMarker.getPosition());
//       return false;
//     });

//     //Setup CLICK handler for map to close an open InfoWindow for any marker
//     google.maps.event.addListener(gMap, 'click', function () {
//       if (openWindow) {
//         openWindow.close();
//       }
//     });
//   }

//   function getMapOptions() {
//     return {
//       zoom: 1,
//       minZoom: 5,
//       maxZoom: 20,
//       scrollwheel:false,
//       center: new google.maps.LatLng(0.00, 0.00),
//       mapTypeId: google.maps.MapTypeId.ROADMAP,
//       mapTypeControl: false,
//       disableDefaultUI: false,
//       styles: [
//         {
//           "featureType": "landscape.man_made",
//           "elementType": "labels",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "landscape",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#ffffff" }]
//         },
//         {
//           "featureType": "landscape.natural.terrain",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#000000" }]
//         },
//         {
//           "featureType": "landscape.man_made",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#f2f0f0" }]
//         },
//         {
//           "featureType": "landscape.natural.landcover",
//           "elementType": "geometry.fill",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "poi",
//           "elementType": "geometry.fill",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "poi",
//           "elementType": "labels.text.fill",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "poi",
//           "elementType": "labels.icon",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "administrative",
//           "elementType": "labels.text.fill",
//           "stylers": [{ "color": "#a5a19e" }]
//         },
//         {
//           "featureType": "road.arterial",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#dfdcdb" }]
//         },
//         {
//           "featureType": "road.arterial",
//           "elementType": "geometry.stroke",
//           "stylers": [{ "color": "#cccccc" }]
//         },
//         {
//           "featureType": "road",
//           "elementType": "labels.text.fill",
//           "stylers": [{ "color": "#afaba8" }]
//         },
//         {
//           "featureType": "road",
//           "elementType": "labels.text.stroke",
//           "stylers": [{ "visibility": "off" }]
//         },
//         {
//           "featureType": "road.highway",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#cccccc" }]
//         },
//         {
//           "featureType": "road.highway",
//           "elementType": "geometry.stroke",
//           "stylers": [{ "color": "#c2bebc" }]
//         },
//         {
//           "featureType": "road.highway",
//           "elementType": "labels.text.fill",
//           "stylers": [{ "color": "#787471" }]
//         },
//         {
//           "featureType": "road.local",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#dfdcdb" }]
//         },
//         {
//           "featureType": "water",
//           "elementType": "geometry.fill",
//           "stylers": [{ "color": "#6EB6DC" }]
//         }
//       ]
//     };
//   }
// }

(function(){

  var community = {
    domCache: function() {
      this.$community     = $('#community');
      this.$loading       = $('#loading');
      this.$filterForm    = $('#filter-form');
      this.$moreFilters   = $('#more-filters');
      this.$filterQuery   = $('#filter-input');
      this.$hiddenFilters = $('[data-js-hook="hidden-filter-row"]');
      this.$tab           = $('[data-js-hook="tab"]');
      this.$tabMap        = $('#tab-map');
      this.$tabList       = $('#tab-list');
      this.$filterView    = $('#filter-view');
      this.$mapCanvas     = $('#map_canvas');
      this.$columnLeft    = $('#column-left');
      this.$columnRight   = $('#column-right');
      this.$filterResults = $('#filter-results-container');

      this.$communityToggle = $('[data-community-toggle]');
      this.$communitySection = $('[data-community-section]');
    },

    filter: function() {
      var self = this;
      var interval = {
        instance: null,
        count: 0,
        limit: 30,
        interval: 100
      }
      // -- Listen for form submission and respond
      this.$filterForm.on('submit', function(){
        interval.instance = setInterval(function(){
          if (self.$filterForm.data('complete') || interval.count === interval.limit) {
            clearInterval(interval.instance);
            resetMap();
            self.bindListing();
          }
          interval.count = interval.count + 1;
        }, interval.interval);
      });

      // -- Expand Filters
      this.$moreFilters.click(function(e){
        e.preventDefault();
        self.$hiddenFilters.slideToggle(200);
      });

      // -- Look for `query` value on load and prompt form submission
      if (this.$filterQuery.val() !== '') {
        this.$filterForm.submit();
      }

      if (typeof select_state != 'undefined') {
        $('[data-js-hook="filter-select"]').filter('[name="state"]').val(select_state);
        this.$filterForm.submit();
      }
    },

    tabs: function() {
      var self = this;

      this.$tab.click(function(e){
        e.preventDefault();
        var activeClass = 'community__tab-link--active';
        var view = $(this).data('js-view');

        // -- Toggle active tab state
        self.$tab.removeClass(activeClass);
        $(this).addClass(activeClass);

        // -- Inject new `view` value and re-submit form
        self.$filterView.val(view);
        self.$filterForm.submit();

        // -- Remove map & add classes where needed
        if (view === 'list') {
          self.$columnLeft.hide();
          self.$mapCanvas.hide();
          self.$columnRight.addClass('community__column--slim');
          self.$filterResults.addClass('community__listing--stretch');
        } else {
          self.$columnLeft.show();
          self.$mapCanvas.show();
          self.$columnRight.removeClass('community__column--slim');
          self.$filterResults.removeClass('community__listing--stretch');
        }
      });
    },

    mobileViewSwap: function(width) {
      var self = this;
      var viewSwitched = false;
      $(window).on('load resize', function(){
        if ($(window).width() <= width) {
          if (!viewSwitched) {
            self.$tabList.trigger('click');
            viewSwitched = true;
          }
        } else {
          viewSwitched = false;
        }
      });
    },

    bindListing: function() {
      var $communityToggle = $('[data-community-toggle]');
      var $communitySection = $('[data-community-section]');

      $communityToggle.click(function(e){
        e.preventDefault();

        $communityToggle.filter('[data-community-toggle="' + $(this).data('community-toggle') + '"]').removeClass('active');
        $(this).addClass('active');

        $communitySection.filter('[data-community-section="' + $(this).data('community-toggle') + '"]').hide();
        $communitySection.filter('[data-name="' + $(this).data('target') + '"]').show();
      });
    },

    init: function() {
      var self = this;

      this.domCache();
      // this.filter();
      this.tabs();
      this.mobileViewSwap(1180);

      this.bindListing();
    }
  };

  $(document).ready(community.init());
})();

(function(){
  var ebrochure = {
    dom: function() {
      this.$ebrochureForm      = $('#ebrochure');
      this.$ebrochureError     = $('#ebrochure-error');
      this.$ebrochureRow       = $('[data-js-hook="ebrochure-row"]');
      this.$ebrochureEmailForm = $('#ebrochure-email');
      this.$ebrochureConfirm   = $('#formConfirm');
      this.$checkbox           = $('[data-js-hook="checkbox"]');
    },

    validateSelection: function() {
      var self = this;
      this.$ebrochureForm.submit(function(e){
        var checked = [];

        self.$checkbox.each(function(){
          if ($(this).prop('checked')) {
            checked.push(1);
          }
        });
        
        if (checked.length) {
          self.$ebrochureError.hide();
        } else {
          e.preventDefault();
          self.$ebrochureError.show();
        }
      });
    },

    emailForm: function() {
      // this.$ebrochureEmailForm.formulate({
      //   require: 'brochureEmail{email}',
      //   errorClass: 'ebrochure__input--error',
      //   inlineMsg: true,
      //   inlineMsgClass: 'ebrochure__inline-msg',
      //   ajax: false
      // });
    },

    rowSelect: function() {
      this.$checkbox.click(function(e){
        e.stopPropagation();
      });

      this.$ebrochureRow.click(function(e){
        var $checkbox = $('#' + $(this).data('checkbox'));
        if ($checkbox.prop('checked')) {
          $checkbox.prop('checked', false);
        } else {
          $checkbox.prop('checked', true);
        }
      });
    },

    ready: function() {
      this.dom();
      this.validateSelection();
      this.emailForm();
      this.rowSelect();
    }
  };

  $(function(){
    ebrochure.ready();
  });
})();
(function($) {
  'use strict';

  var floorplan = {
    dom: function() {
      this.$floorplanFilter = $('#floorplan-filter-form');

      this.$bedroomFilterInput = $('#bedroom-filter-input');
      this.$bedroomCheckbox = $('[data-js-hook="bedroom-checkbox"]');
      this.$bedroomFilter = $('[data-js-hook="bedroom-filter"]');
      this.$bedroomClear = $('#bedroom-clear');

      this.$floorplanFilterSelect = $('[data-js-hook="floorplan-filter-select"]');
      this.$resetFilters = $('#reset-filters');

      this.$availableUnits = $('#available-units');
      this.$availableUnitsText = $('#available-units-text');
      this.$availableCheckbox = $('#available');

      this.$expandFilters = $('#expand-filters');
      this.$filters = $('#filters');
      this.$expandAdvancedFilters = $('#expand-advanced-filters');
      this.$advancedFilters = $('#advanced-filters');

      this.$floorplans = $('[data-js-hook="floorplan"]');
      this.$filterResults = $('#filter-results');
      this.$filterResultsCount = $('#filter-results-count');
      this.$noResultMessage = $('#no-result-message');

      this.$launchEmbed  = $('#launch-embed');
      this.$embedFrame = $('#embed-frame');
      this.$embedFrameWrap = $('#embed-frame-wrap');
      this.$mobileEmbed = $('#mobile-embed');
      this.$viewToggle = $('[data-toggle-view]');
      this.$view = $('[data-view]');
    },

    data: {
      floorplanData: typeof preload != 'undefined' ? preload.floorplans : false,
      activeBedroomLinkClass: 'floorplan-filter__bed-link--active',
      activeAvailableNowClass: 'floorplan-filter__button--active',
      activeFilterResultsClass: 'floorplan-filter__results--active'
    },

    validateFloorplan: function(floorplanDetails, criteria) {

      if (floorplanDetails.bedroom && criteria.bedroom && criteria.bedroom.length && criteria.bedroom.indexOf('' + floorplanDetails.bedroom) <= -1) {
        return false;
      }

      if ((criteria.rent_min && !floorplanDetails.rent_min) || (criteria.rent_max && !floorplanDetails.rent_max)) {
        return false;
      }

      // -- Min Rent validation.
      if (floorplanDetails.rent_max && !criteria.rent_max && criteria.rent_min && floorplanDetails.rent_max < criteria.rent_min) {
        return false;
      }

      // -- Max Rent validation.
      if (floorplanDetails.rent_min && !criteria.rent_min && criteria.rent_max && floorplanDetails.rent_min > criteria.rent_max) {
        return false;
      }

      // -- Min & Max Rent validation.
      if (floorplanDetails.rent_min && floorplanDetails.rent_max && criteria.rent_min && criteria.rent_max && (floorplanDetails.rent_min > criteria.rent_max || floorplanDetails.rent_max < criteria.rent_min)) {
        return false;
      }

      // -- Square Feet Range validation.
      if (floorplanDetails.square_feet && criteria.sq_feet_min && criteria.sq_feet_max) {
        if (floorplanDetails.square_feet < criteria.sq_feet_min || floorplanDetails.square_feet > criteria.sq_feet_max) {
          return false;
        }
      } else if (floorplanDetails.square_feet && criteria.sq_feet_min) {
        if (floorplanDetails.square_feet < criteria.sq_feet_min) {
          return false;
        }
      } else if (floorplanDetails.square_feet && criteria.sq_feet_max) {
        if (floorplanDetails.square_feet > criteria.sq_feet_max) {
          return false;
        }
      }

      if (criteria.availability) {
        var hasUnitAvailableNow;

        if (!floorplanDetails.availability || !floorplanDetails.availability.length) {
          hasUnitAvailableNow = false;
        } else {
          var now = new Date().getTime();
          hasUnitAvailableNow = floorplanDetails.availability.some(function(availability){
            return new Date(availability).getTime() <= now;
          });
        }

        return hasUnitAvailableNow;
      }

      return true;
    },

    toggleFloorplanVisibility: function(floorplanIds) {
      var self = this;
      this.$floorplans.hide();
      this.$filterResults.slideDown(100).addClass(self.data.activeFilterResultsClass);
      this.$filterResultsCount.text(floorplanIds.length);

      setTimeout(function(){
        self.$filterResults.removeClass(self.data.activeFilterResultsClass);
      }, 300);

      if (floorplanIds.length) {
        this.$noResultMessage.hide();
        floorplanIds.forEach(function(id){
          self.$floorplans.filter('[data-floorplan="' + id + '"]').show();
        });
      } else {
        this.$noResultMessage.show();
      }
    },

    mayUseStorage: function() {
      try {
        localStorage.use_storage = 1;

        return true;
      } catch (e) {
        return false;
      }
    },

    filter: function() {
      var self = this;

      this.$expandAdvancedFilters.click(function(e){
        e.preventDefault();
        console.log('click');
        var $this = $(this);

        self.$advancedFilters.slideToggle(100, function(){
          $this.text(self.$advancedFilters.is(':visible') ? 'Hide Advanced Filters': 'Show Advanced Filters');
        });
      });

      this.$expandFilters.click(function(e){
        e.preventDefault();
        var $this = $(this);
        self.$filters.slideToggle(200, function(){
          $this.text(self.$filters.is(':visible') ? 'Collapse Filters -' : 'Expand Filters +');
        });
      });

      this.$resetFilters.click(function(e){
        e.preventDefault();
        self.$floorplanFilterSelect.val('');
        self.$availableCheckbox.prop('checked', false).trigger('change');
        self.$bedroomFilter.filter('[data-clear-bedroom]').trigger('click');
      });

      this.$availableUnits.click(function(e){
        e.preventDefault();
        self.$availableCheckbox.prop('checked', !self.$availableCheckbox.prop('checked')).trigger('change');
        self.$floorplanFilter.submit();
      });

      this.$availableCheckbox.change(function(){
        if (self.$availableCheckbox.prop('checked')) {
          self.$availableUnits.addClass(self.data.activeAvailableNowClass);
          self.$availableUnitsText.text('Show All Availability');
        } else {
          self.$availableUnits.removeClass(self.data.activeAvailableNowClass);
          self.$availableUnitsText.text('Show Available Now');
        }
      });

      this.$floorplanFilterSelect.change(function(e){
        self.$floorplanFilter.submit();
      });

      this.$bedroomFilter.click(function(e){
        e.preventDefault();
        var allUnchecked = true;

        if ($(this).attr('data-clear-bedroom')) {
          self.$bedroomCheckbox.prop('checked', false);
          self.$bedroomFilter.removeClass(self.data.activeBedroomLinkClass);
          $(this).addClass(self.data.activeBedroomLinkClass);
        } else {
          var $checkbox = $(this).next().filter(self.$bedroomCheckbox);

          $checkbox.prop('checked', !$checkbox.prop('checked'));
          $(this).toggleClass(self.data.activeBedroomLinkClass);
          self.$bedroomFilter.filter('[data-clear-bedroom]').removeClass(self.data.activeBedroomLinkClass);
        }

        self.$bedroomCheckbox.each(function(){
          if ($(this).prop('checked')) {
            allUnchecked = false;
          }
        });

        if (allUnchecked) {
          self.$bedroomFilter.filter('[data-clear-bedroom]').addClass(self.data.activeBedroomLinkClass);
        }

        self.$floorplanFilter.submit();
      });

      this.$floorplanFilter.submit(function(e){
        e.preventDefault();
        var cacheFilters = false;
        var dataObject = {};
        var matchedResults = [];

        $(this).serializeArray().forEach(function(data){
          if (data.value) {
            cacheFilters = true;
          }

          if (data.name.match(/\[\]$/)) {
            var prop = data.name.replace(/\[\]$/, '');

            if (!dataObject[prop]) {
              dataObject[prop] = [];
            }

            dataObject[prop].push(data.value);
          } else {
            dataObject[data.name] = data.value;
          }
        });

        if (self.mayUseStorage()) {
          if (cacheFilters) {
            localStorage.setItem('floorplan-filters', JSON.stringify(dataObject));
          } else {
            localStorage.removeItem('floorplan-filters');
          }
        }

        for (var id in self.data.floorplanData) {
          if (self.data.floorplanData[id]) {
            var floorplan = self.data.floorplanData[id];
            if (self.validateFloorplan(floorplan, dataObject)) {
              matchedResults.push(floorplan.id);
            }
          }
        }

        self.toggleFloorplanVisibility(matchedResults);
      });

      if (self.mayUseStorage() && localStorage.getItem('floorplan-filters')) {
        var data = JSON.parse(localStorage.getItem('floorplan-filters'));
        var expandAdvanced = false;

        for (var property in data) {
          if (data[property]) {
            var $field;
            var value = data[property];
            switch (property) {
              case 'bedroom':
                if (value.length) {

                  $('[data-clear-bedroom]').removeClass('floorplan-filter__bed-link--active');

                  for (var i = 0; i < value.length; i++) {
                    var bedroomValue = value[i];
                    $field = self.$bedroomFilter.filter('[data-bed="' + bedroomValue + '"]');

                    if ($field.length) {
                      $field.trigger('toggle-selection');
                    }
                  }
                }

                break;
              case 'availability':
                if (value && value != '') {
                  expandAdvanced = true;
                  self.$availableCheckbox.val(value);
                }

                break;
              default:
                $field = self.$floorplanFilter.find('[name="' + property + '"]');

                if ($field.length && value) {
                  expandAdvanced = true;
                  $field.val(value);
                }

                break;
            }
          }
        }

        if (expandAdvanced && self.$expandAdvancedFilters.length) {
          self.$expandAdvancedFilters.trigger('click');
        }

        self.$floorplanFilter.submit();
      }
    },

    views: function() {
      var self = this;

      this.$launchEmbed.click(function(e){
        e.preventDefault();
        self.$embedFrame.show();
      });

      this.$embedFrame.click(function(){
        $(this).hide();
      });

      this.$viewToggle.click(function(e){
        e.preventDefault();
        var view = $(this).data('toggle-view');

        self.$viewToggle.removeClass('floorplan-toggle__tab--active');

        $(this).addClass('floorplan-toggle__tab--active');

        self.$view.hide();
        self.$view.filter('[data-view="' + view + '"]').show();

        if (view == 'embed' && self.$embedFrame.attr('data-src')) {
          self.$embedFrame.attr('src', self.$embedFrame.data('src')).removeAttr('data-src');
        }

        if (self.mayUseStorage()) {
          localStorage.setItem('floorplan-view', view);
        }
      });

      if (self.mayUseStorage() && localStorage.getItem('floorplan-view')) {
        var $toggle = self.$viewToggle.filter('[data-toggle-view="' + localStorage.getItem('floorplan-view') + '"]');

        if ($toggle.length) {
          $toggle.trigger('click');
        }
      }

      $('body').on('fya-height-update', function(event, data){
        self.$embedFrameWrap.css('padding-bottom', 0).height(data.height);
        $('html, body').animate({scrollTop: self.$embedFrameWrap.offset().top}, 100);
      });

      if (this.$mobileEmbed.length) {
        this.$mobileEmbed.magnificPopup({
          type: 'iframe',
          mainClass: 'interactive-embed',
          closeMarkup: '<button title="%title%" type="button" class="mfp-close">Back to Site</button>'
        });
      }
    },
    ready: function() {
      this.dom();
      this.filter();
      this.views();
    }
  };

  $(function() {
    if (typeof preload != 'undefined') {
      floorplan.ready();
    }
  });

})(jQuery);

(function(){
  var floorplan = {
    dom: function() {
      this.$floorSelect = $('#floor-select');
      this.$floorToggle = $('[data-js-hook="floor-toggle"]');
      this.$dimensionToggle = $('[data-js-hook="dimension-toggle"]');
      this.$floorplanImage = $('[data-js-hook="floorplan-image"]');
      this.$dimensionWrap = $('[data-js-hook="dimension-wrap"]');
      this.$toggleDimensionWrap = $('#toggle-dimension-wrap');
      this.$togglePanel = $('[data-js-hook="toggle-panel"]');
      this.$panel = $('[data-js-hook="panel"]');
      this.$toggleLeaseTerm = $('[data-js-hook="expand-lease-term"]');
      this.$leaseTerm = $('[data-js-hook="lease-term"]');
      this.$toggleWalkthrough = $('[data-toggle-walkthrough]');
      this.$walkthrough = $('[data-walkthrough]');
    },

    data: {
      activeToggleClass: 'floorplan-details__toggle-link--active',
      activeButtonClass: 'floorplan-details__button--active'
    },

    floorToggle: function() {
      var self = this;

      this.$floorToggle.click(function(e){
        e.preventDefault();
        self.$floorToggle.removeClass(self.data.activeToggleClass);
        $(this).addClass(self.data.activeToggleClass);
        self.$floorplanImage.hide().filter('[data-dimension="' + $(this).data('dimension') + '"]').filter('[data-floor="' + $(this).data('floor') + '"]').show();
      });

      this.$floorSelect.click(function(e){
        e.preventDefault();
        $(this).next().slideToggle(100);
      });
    },  

    dimensionToggle: function() {
      var self = this;

      this.$dimensionToggle.click(function(e){
        e.preventDefault();
        var dimension = $(this).data('dimension');
        self.$dimensionToggle.removeClass(self.data.activeToggleClass);
        $(this).addClass(self.data.activeToggleClass);
        self.$dimensionWrap.hide().filter('[data-dimension="' + dimension + '"]').show();
        self.$floorToggle.filter('[data-dimension="' + dimension + '"]').first().trigger('click');
      });
    },

    togglePanel: function() {
      var self = this;

      this.$togglePanel.click(function(e){
        e.preventDefault();
        var $panel = self.$panel.filter('[data-type="' + $(this).data('panel') + '"]');
        self.$togglePanel.removeClass(self.data.activeButtonClass);
        $(this).addClass(self.data.activeButtonClass); 
        
        self.$panel.slideUp(200);
        
        if (!$panel.is(':visible')) {
          $panel.slideDown(200, function(){
            $('html, body').animate({scrollTop: $panel.outerHeight() > $(window).height() ? $panel.offset().top - 20 : ($panel.offset().top - $(window).height()/2 + $panel.outerHeight()/2)});
          });
        } else {
          $(this).removeClass(self.data.activeButtonClass); 
        }
      }); 
    },

    toggleLeaseTerm: function() {
      var self = this;

      this.$toggleLeaseTerm.click(function(e){
        e.preventDefault();
        self.$leaseTerm.filter('[data-unit="' + $(this).data('unit') + '"]').toggle();
      });
    },

    toggleWalkthrough: function() {
      var self = this;

      this.$toggleWalkthrough.click(function(e){
        e.preventDefault();
        var $this = $(this);
        var $walkthrough = self.$walkthrough.filter('[data-walkthrough=' + $this.data('toggle-walkthrough') + ']');
        var $altToggle = self.$toggleWalkthrough.filter('[data-toggle-walkthrough=' + ($this.data('toggle-walkthrough') == 1 ? 2 : 1) + ']');

        if ($altToggle.data('open')) {
          $altToggle.trigger('click');
        }

        if ($this.data('open')) {
          $walkthrough.hide();
          $this.removeClass('floorplan-details__toggle-link--active floorplan-details__toggle-link--active-walkthrough').find('span').remove();
          $this.data('open', 0);
          self.$toggleDimensionWrap.show();
        } else {
          $walkthrough.show();
          $this.addClass('floorplan-details__toggle-link--active floorplan-details__toggle-link--active-walkthrough').append('<span>&times;</span>');
          $this.data('open', 1);
          self.$toggleDimensionWrap.hide();
        }

        
      }); 
    },

    ready: function() {
      this.dom();
      this.floorToggle();
      this.dimensionToggle();
      this.togglePanel();
      this.toggleLeaseTerm();
      this.toggleWalkthrough();
    }
  }

  $(function(){
    floorplan.ready();
  });
})();
(function($) {

  var gallery = {
    dom: function() {
      this.$tab = $('[data-js-hook="tab"]');
      this.$container = $('#gallery-container');
      this.$loading = $('#loading');
      this.$openCategories = $('[data-js-hook="open-gal-categories"]');
      this.$tabWrap = $('#tab-wrap');
    },

    data: function() {
      this.layout = this.$container.data('layout');
    },

    tab: function() {
      var self = this;

      this.$tab.click(function(e){
        e.preventDefault();
        var $this = $(this);
        var action = $(this).data('action');
        var showLoader = setTimeout(function(){
          self.$loading.fadeIn(200);
        }, 500);

        self.$container.load(action, {category: $(this).data('category'), layout: self.layout}, function(){
          clearTimeout(showLoader);
          self.$loading.fadeOut(200);
          self.$tab.removeClass('active');
          $this.addClass('active');
          self.$openCategories.text($this.text());
          self.swipebox();

          if ($(window).width() <= 808) {
            self.$tabWrap.slideUp(100);
          }

          if (self.layout === 2) {
            self.rotator();
            self.layoutToggle();
          }
        });
      });

      this.$openCategories.click(function(e){
        e.preventDefault();
        self.$tabWrap.slideToggle(100);
      });
    },

    rotator: function() {
      $('#pager').flexslider({
        animation: 'slide',
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 218,
        itemMargin: 20,
        asNavFor: '#rotator'
      });

      $('#rotator').flexslider({
        animation: 'slide',
        controlNav: false,
        directionNav: false,
        animationLoop: false,
        slideshow: false,
        sync: '#pager',
        before: function() {
          $('#swipe').fadeOut(80);
        }
      });
    },

    layoutToggle: function() {
      $('[data-js-hook="layout-toggle"]').click(function(e){
        e.preventDefault();
        $('[data-js-hook="layout-toggle"]').removeClass('gallery2__layout-toggle-button--active');
        $(this).addClass('gallery2__layout-toggle-button--active');
        $('[data-js-hook="layout"]').hide();
        $('[data-js-hook="layout"]').filter('[data-layout="' + $(this).data('layout') + '"]').show();
      });
    },

    swipebox: function() {
      $('[data-js-hook="gallery-swipebox"]').unbind().swipebox({
        hideBarsDelay: false,
        removeBarsOnMobile: false,
        loopAtEnd: true,
        afterOpen: function(){
          // -- Trigger close event on #swipebox-container click event.
          $('#swipebox-container').click(function(e){
            e.preventDefault();
            $('#swipebox-close').trigger('click');
          });
          // -- Wait for image to load after open, then bind click events
          // -- to disable propogation from certain elements.
          var interval;
          interval = setInterval(function(){
            if ($('#swipebox-slider .slide.current img').length) {
              clearInterval(interval);
              $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                e.stopPropagation();
              });
            }
          }, 200);
        }
      });
    },

    ready: function() {
      this.dom();
      this.data();
      this.tab();
      this.swipebox();
      if (this.layout === 2) {
        this.rotator();
        this.layoutToggle();
      }
    }
  };

  $(function(){
    gallery.ready();
  });

})(jQuery);

function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}

(function(){

	var index = {
		domCache: function() {
			this.$rotator      = $('#rotator');
			this.$aboutButton  = $('#expand-button');
			this.$aboutBody    = $('#about-hidden');
			this.$searchForm   = $('#index-search-form');
			this.$searchSubmit = $('#index-search-submit');
			this.$searchClear  = $('#index-search-clear');
			this.$searchInput  = $('#index-search-input');
		},

		flexslider: function() {
			this.$rotator.flexslider({
				controlNav: false,
				directionNav: true,
				// -- Comment out Controls Container if
				// -- you intend to use controlNav
				controlsContainer: '.flex-direction-nav-container'
			});

      $('[data-js-hook="rotator"]').flexslider({
        controlNav: true,
        directionNav: false
      });

			$('#gallery-rotator').flexslider({
				controlNav: true,
				directionNav: false
			});
		},

		about: function() {
			this.$aboutButton.click(function(e){
				e.preventDefault();
				this.$aboutBody.slideToggle(100);
			});
		},

		indexSearch: function() {
			var self = this;

			this.$searchInput.on('change', function(){
				self.$searchForm.submit();
			});

			this.$searchSubmit.click(function(e){
				e.preventDefault();
				self.$searchForm.submit();
			});

			this.$searchClear.click(function(e){
				e.preventDefault();
				self.$searchInput.val('');
				self.$searchClear.hide();
			});
		},

		init: function() {
			this.domCache();
			this.flexslider();
			this.about();
			this.indexSearch();

			$('[data-js-hook="gallery-video"]').magnificPopup({
 				type: 'iframe'
      });
		}
	}

	$(document).ready(index.init());
})();

(function($){
  'use strict';

  var init = {
    domCache: function() {
      // -- Misc
      this.$html  = $('html, body');
      this.$page  = $('#page');
      this.$email = $('[data-mail-name]');

      // -- Mobile Nav
      this.$hamburger = $('#hamburger');
      this.$mobileNav = $('#mobile-nav');

      // -- Sidebar
      this.$sidebarToggle     = $('#sidebar-toggle');
      this.$sidebarToggleText = $('#sidebar-toggle-text');
      this.$sidebarToggleIcon = $('#sidebar-toggle-icon');
      this.$sidebarNav        = $('#sidebar-nav');

      // -- Filter
      this.$filterForm   	 = $('#filter-form');
      this.$filterLoading  = $('#filter-loading');
      this.$filterSelect 	 = $('[data-js-hook="filter-select"]');
      this.$filterResults	 = $('#filter-results-container');
      this.$filterInput 	 = $('#filter-input');
      this.$filterClear		 = $('#filter-clear');
      this.$filterClearAll = $('#filter-clear-all');
      this.$filterToggle 	 = $('#filter-toggle');
      this.$clearFilters   = $('#clear-all');
      this.$formLoader     = $('.form__loading');

      // -- Infield Label
      this.$infieldLabels = $('[data-infield-label]');

      // -- Pick A Date
      this.$datePicker    = $('[data-js-hook="pickadate"]');

      // -- Form Stuff
      this.$propertyContactForm = $('#property-contact-form');
      this.$contactForm         = $('#contact-form');
      this.$tourForm            = $('#schedule-a-tour-form');

      this.$slider      = $('[data-js-hook="slider"]');

      // -- Modal
      this.$modal = $('[data-js-hook="swipebox"],[target="popup"]');

      // -- Next Section
      this.$nextSection = $('[data-js-hook="nextSection"]');

      // -- Facebook Feed container
      this.$facebookFeed = $('#facebook-feed');
    },

    mobileNav: function() {
      var self = this;
      this.$hamburger.click(function(e){
        e.preventDefault();
        self.$mobileNav.slideToggle(200);
      });
    },

    sidebar: function() {
      var self = this;
      this.$sidebarToggle.click(function(e){
        e.preventDefault();
        self.$sidebarNav.slideToggle(100, function(){
          var sidebarToggleText = self.$sidebarNav.is(':visible') ? 'Hide Menu' : 'Show Menu';
          var sidebarToggleIcon = self.$sidebarNav.is(':visible') ? '-' : '+';
          self.$sidebarToggleText.text(sidebarToggleText);
          self.$sidebarToggleIcon.text(sidebarToggleIcon);
        });
      });
    },

    pagination: function() {
      var self = this;
      // -- Cache DOM here since we re-call self.pagination()
      // -- in `load` callback and need to re-cache nodes.
      this.$pagination = $('#pagination');
      this.$paginationLink = $('#pagination').find('a');
      this.$paginationLink.click(function(e){
        e.preventDefault();
        $(self.$pagination.data('load-in')).load($(this).attr('href'), {}, function(){
          self.$html.animate({scrollTop: self.$page.offset().top});
          self.pagination();
        });
      });
    },

    filter: function() {
      var self = this;
      var timeout;

      // -- Filter Form Submit
      this.$filterForm.submit(function(e){
        e.preventDefault();
        var values = false;

        self.$filterLoading.fadeIn(200);

        if (self.$filterInput.val() !== '') {
          values = true;
        }

        self.$filterSelect.each(function(select){
          if ($(self.$filterSelect[select]).val() != null && $(self.$filterSelect[select]).val().length) {
            values = true;
          }
        });

        if (values) {
          self.$filterClearAll.fadeIn(200);
        } else {
          self.$filterClearAll.fadeOut(200);
        }

        self.$filterForm.data('complete', false);
        self.$filterResults.load($(this).attr('action'), $(this).serialize(), function() {
          self.$filterForm.data('complete', true);
          setTimeout(function(){
            self.$filterLoading.fadeOut(200);
            self.pagination();
          }, 200);
        });
      });

      // -- Filter Select Change
      this.$filterSelect.change(function() {
        var $name = $(this).attr('name');
        var $val = $(this).val();
        var $url = $val ? '?' + $name + '=' + $val : '';
        history.pushState(null,'', window.location.pathname + $url);
        self.$filterForm.submit();
      });

      // -- Filter While Typing
      this.$filterInput.on('input', function(){
        var val = $(this).val().trim();

        if (val === '') {
          self.$filterForm.submit();
          self.$filterClear.hide();
          self.$filterInput.removeClass('filter__field--has-value');
        } else {
          self.$filterClear.show();
          self.$filterInput.addClass('filter__field--has-value');
          clearTimeout(timeout);
          timeout = setTimeout(function(){
            self.$filterLoading.fadeIn(200);
            self.$filterForm.submit();
          }, 600);
        }
      });

      // -- Filter Clear
      this.$filterClear.click(function(e){
        e.preventDefault();
        self.$filterClear.hide();
        self.$filterInput.val('');
        self.$filterForm.submit();
      });

      this.$filterClearAll.click(function(e){
        e.preventDefault();
        self.$filterInput.val('');
        self.$filterClear.hide();
        self.$filterSelect.each(function(select){
          $(self.$filterSelect[select]).val('');
        });
        self.$filterForm.submit();
      });

      // -- Filter Toggle Mobile
      this.$filterToggle.click(function(e){
        e.preventDefault();
        self.$filterToggle.slideUp(200);
        self.$filterForm.slideDown(200);
      });
    },

    infieldLabels: function() {
      this.$infieldLabels.inFieldLabels();
    },

    pickadate: function() {
      this.$datePicker.pickadate({
        onClose: function() {
          this.$holder.blur();
        }
      });
    },

    waitForFormulate: function() {
      return new Promise((resolve, reject) => {
        let i = 0;
        let interval = setInterval(() => {
          ++i;

          if (typeof $.fn.formulateNC !== 'undefined') {
            clearInterval(interval);
            resolve();
          }

          if (i >= 100) {
            clearInterval(interval);
            reject();
          }
        });
      });
    },

    forms: function() {
      var self = this;

      var propertyContactRequireFields = 'First Name, Last Name, Email{email}, Phone, Lead Source, Contact Method, Looking For, Move In Date';
      // propertyContactRequireFields += ', Address, City, State, Zip';

      this.waitForFormulate().then(() => {
        // -- Validate the form
        this.$propertyContactForm.formulateNC({
          require: propertyContactRequireFields,
          errorClass: 'error',
          errorParent: true,
          showOnSubmit: '#contact-confirm',
          inlineMsg: true,
          inlineMsgClass: 'form__inline-error',
          fireOnSubmit: function() {
            self.$formLoader.fadeIn(200);
            $('.form__error', self.$propertyContactForm).remove();
          },
          fireOnSuccess: function() {
            self.$formLoader.fadeOut(200);
            $('.form__error', self.$propertyContactForm).remove();
            cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
          },
          fireOnError: function(data){
            self.$formLoader.fadeOut(200);
            var $error = $('.form__error', self.$propertyContactForm);
            $('.form__loading', self.$propertyContactForm).fadeOut();
            if (data) {
              if (!$error.length) {
                self.$propertyContactForm.prepend('<div class="form__error"></div>');
                $error = $('.form__error', self.$propertyContactForm);
              }
              $error.html(data);
            }
            else if ($error.length) {
              $error.remove();
            }
            $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
          }
        });

        // -- Validate the form
        this.$contactForm.formulateNC({
          require:        'First Name, Last Name, Email{email}, Cell Phone, Lead Source, Interest[]',
          errorClass:     'error',
          errorParent:    true,
          showOnSubmit:   '#contact-confirm',
          inlineMsg:      true,
          inlineMsgClass: 'form__inline-error',
          fireOnSubmit:   function () {
            self.$formLoader.fadeIn(200);
            $('.form__error', self.$contactForm).remove();
          },
          fireOnSuccess:  function () {
            self.$formLoader.fadeOut(200);
            $('.form__error', self.$contactForm).remove();
            cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
          },
          fireOnError:    function (data) {
            self.$formLoader.fadeOut(200);
            var $error = $('.form__error', self.$contactForm);
            $('.form__loading', self.$contactForm).fadeOut();
            if (data) {
              if (!$error.length) {
                self.$contactForm.prepend('<div class="form__error"></div>');
                $error = $('.form__error', self.$contactForm);
              }
              $error.html(data);
            } else if ($error.length) {
              $error.remove();
            }
            $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
          }
        });

        // -- Validate the form
        this.$tourForm.formulateNC({
          require: 'First Name, Last Name, Email{email}, Phone, MoveIn Date',
          errorClass: 'form__field--error',
          showOnSubmit: '#schedule-a-tour-confirm',
          inlineMsg: true,
          inlineMsgClass: 'form__inline-error',
          fireOnSubmit: function() {
            self.$formLoader.fadeIn(200);
            $('.form__error', self.$tourForm).remove();
          },
          fireOnSuccess: function() {
            self.$formLoader.fadeOut(200);
            $('.form__error', self.$tourForm).remove();
            cmg_google_conversion($('#schedule_tour_conversion').val(), $('#schedule_tour_conversion_id').val(), $('#schedule_tour_conversion_html').val());
          },
          fireOnError: function(data){
            self.$formLoader.fadeOut(200);
            var $error = $('.form__error', self.$tourForm);
            $('.form__loading', self.$tourForm).fadeOut();
            if (data) {
              if (isJson(data)) {
                data = jQuery.parseJSON(data);
                if (data.message.length) {
                  data = data.message;
                }
              }
              if (!$error.length) {
                self.$tourForm.prepend('<div class="form__error"></div>');
                $error = $('.form__error', self.$tourForm);
              }
              $error.html(data);
            }
            else if ($error.length) {
              $error.remove();
            }
            $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
          }
        });
      });
    },

    email: {
      convert: function($element) {
        var email = $element.data('mail-name') + '@' + $element.data('mail-host');
        $element.attr('href', 'mailto:' + email);
        if ($element.text() === '') {
          $element.text(email);
        }
        $element.removeAttr('data-mail-name');
        $element.removeAttr('data-mail-host');
      },

      mailToInject: function(el) {
        var self = init;
        if (el) {
          this.email.convert(el);
        } else {
          self.$email.each(function(){
            self.email.convert($(this));
          });
        }
      }
    },

    modal: function() {
      this.$modal.swipebox({
        hideBarsDelay: false,
        removeBarsOnMobile: false,
        loopAtEnd: true,
        afterOpen: function(){
          // -- Trigger close event on #swipebox-container click event.
          $('#swipebox-container').click(function(e){
            e.preventDefault();
            $('#swipebox-close').trigger('click');
          });
          // -- Wait for image to load after open, then bind click events
          // -- to disable propogation from certain elements.
          var interval;
          interval = setInterval(function(){
            if ($('#swipebox-slider .slide.current img').length) {
              clearInterval(interval);
              $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                e.stopPropagation();
              });
            }
          }, 200);
        }
      });
    },

    lazyLoad: function() {
      $('.lazy-load, [data-src]').lazyload();
    },

    nextSection: function() {
      this.$nextSection.click(function(event) {
        event.preventDefault();
        var target = $(this).data('target');
        $('html, body').animate({
          scrollTop: $(target).offset().top
        });
      });
    },

    wcagFixes: function() {
      setTimeout(function() {
        // - Betterbot
        $('img[src="https://dashboard.betterbot.ai/embed/images/close.png"]').attr('alt','betterbot close icon');
        $('img.betterbot_chat-btn').attr('alt','betterbot icon');
        // - Hy.ly
        $('#hy-frame-container').attr('title','Hy.ly Schedule A Tour');
        // - Date Picker
        $('.picker__day').removeAttr('aria-activedescendant');
        // - all iframes
        $('iframe').each(function(index) {
          if (!$(this).attr('title')) {
            $(this).attr('title', 'Embed ' + (++index));
          }
          $(this).removeAttr('frameborder').removeAttr('scrolling').removeAttr('width').removeAttr('height');
        });
      }, 2500);
    },

    facebookFeed: function() {
      var $container = this.$facebookFeed;
      if ($container.length && jcms.facebook_feed_id && jcms.facebook_feed_access_token) {
        $container.load('/facebook-feed/', { facebook_id: jcms.facebook_feed_id, facebook_access_token: jcms.facebook_feed_access_token }, function(response) {
          if (response.indexOf('SmashBalloon Error') >= 0) {
            $('.index-facebook').remove();
            console.error(response);
          }
        });
      }
    },

    init: function() {
      this.domCache();
      this.mobileNav();
      this.sidebar();
      this.pagination();
      this.filter();
      this.infieldLabels();
      this.pickadate();
      this.forms();
      this.email.mailToInject();
      this.modal();
      this.lazyLoad();
      this.nextSection();
      this.facebookFeed();

      this.$slider.flexslider({
        directionNav: true,
        controlNav: false
      });

      var $logo = $('.header__logo-image');
      $(window).on('resize load', function(){
        var logoHeight = $logo.outerHeight();

        $('body, .page__wrap').css('background-size', $logo.offset().left + (logoHeight / 2) + 'px');
      });

      var wow = new WOW({
        // boxClass: 'wow',
        // animateClass: 'animated',
        // offset: 50,
        mobile: false,
        live: false
      });

      wow.init();
    }
  };

  $(document).ready(init.init());

  $(window).load(function() {
    init.wcagFixes();
  });

})(jQuery);

(function(){

  var map = {
    dom: function() {
      this.$mapCanvas           = $('#map_canvas');
      this.$zoomIn              = $('#zoom_in');
      this.$zoomOut             = $('#zoom_out');
      this.$refresh             = $('#refresh');
      this.$poiFilter           = $('[data-js-hook="poi-filter"]');
      this.$mainInfoBoxTemplate = $('#main-infobox-template');
      this.$infoBoxTemplate     = $('#infobox-template');
      this.$poiToggleBox        = $('[data-js-hook="toggle-poi-infobox"]');
      this.$poiCategory         = $('[data-js-hook="poi-category"]');
    },

    definitions: function() {
      // -- Probably don't want to touch.
      this.instance;
      this.mainInfoBox;
      this.poiMarkers    = [];
      this.assetPath     = config.siteUrl + mapSettings.assetPath.replace(/^\/|\/$/g, '') + '/';

      // -- You can touch.
      this.zoomIncrement   = 1;
      this.defaultCategory = mapSettings.defaultCategory;
      this.currentCategory = this.defaultCategory;
      this.homeImageFile   = 'map_home.png';
      this.dataEndpoint    = 'neighborhood';
      this.poiIconFormat   = '{{category}}_small';
      this.mainInfoboxHTML = this.$mainInfoBoxTemplate.html();
      this.poiInfoboxHTML  = this.$infoBoxTemplate.html();
      this.mapStyles = [
                        {
                          "featureType": "landscape.man_made",
                          "elementType": "labels",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "landscape",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#ffffff" }]
                        },
                        {
                          "featureType": "landscape.natural.terrain",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#f2f0f0" }]
                        },
                        {
                          "featureType": "landscape.man_made",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#f2f0f0" }]
                        },
                        {
                          "featureType": "landscape.natural.landcover",
                          "elementType": "geometry.fill",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "geometry.fill",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "labels.text.fill",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "poi",
                          "elementType": "labels.icon",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "administrative",
                          "elementType": "labels.text.fill",
                          "stylers": [{ "color": "#a5a19e" }]
                        },
                        {
                          "featureType": "road.arterial",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#dfdcdb" }]
                        },
                        {
                          "featureType": "road.arterial",
                          "elementType": "geometry.stroke",
                          "stylers": [{ "color": "#cccccc" }]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels.text.fill",
                          "stylers": [{ "color": "#afaba8" }]
                        },
                        {
                          "featureType": "road",
                          "elementType": "labels.text.stroke",
                          "stylers": [{ "visibility": "off" }]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#dfdcdb" }]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "geometry.stroke",
                          "stylers": [{ "color": "#c2bebc" }]
                        },
                        {
                          "featureType": "road.highway",
                          "elementType": "labels.text.fill",
                          "stylers": [{ "color": "#787471" }]
                        },
                        {
                          "featureType": "road.local",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#dfdcdb" }]
                        },
                        {
                          "featureType": "water",
                          "elementType": "geometry.fill",
                          "stylers": [{ "color": "#bbcad2" }]
                        },
                      ]
    },

    onGoogleLoad: function(callback){
      var self = this;
      callback();
    },

    loadMap: function(event) {
      map.setOptions();
      map.googleMap = google.maps;
      map.instance = new map.googleMap.Map(map.$mapCanvas[0], map.mapOptions);
      map.bindControls();
      map.googleMap.event.addDomListener(window, 'resize', map.mapResize);

      // -- Place Home Marker
      var mainMarker = new map.googleMap.Marker({
        map: map.instance,
        position: map.latlng,
        icon : map.assetPath + map.homeImageFile
      });

      // -- Build InfoBox & Bind Toggle Controls
      map.mainInfoBox = $.extend(new InfoBox(map.pinpointOptions), {isMain: true});
      map.openMarker(map.mainInfoBox, mainMarker);
      map.bindMarkerOpen(map.mainInfoBox, mainMarker);

      // -- Draw all POIs to map
      mapSettings.pois.forEach(function(point){
        map.drawPoint(point);
      });

      map.poiVisibility(map.currentCategory, event && event.type == 'resize' ? true : false);
    },

    mapResize: function() {
      var boundry = new map.googleMap.LatLngBounds();

      map.poiMarkers.forEach(function(marker){
        if (marker.category == map.currentCategory) {
          boundry.extend(marker.position);
        }
      });

      if ($(window).width() >= 660){
        map.instance.fitBounds(boundry);
        map.instance.setZoom(map.instance.getZoom() - 1);
      } else if ($(window).width() < 660) {
        setTimeout(function(){
          var centerBoundry = new map.googleMap.LatLngBounds().extend(map.latlng);
          map.instance.fitBounds(centerBoundry);
          map.instance.setZoom(map.instance.getZoom() - 7);
        }, 100);
      }
    },

    drawPoint: function(point) {
      var poiInfoboxHTML = this.poiInfoboxHTML.replace(/\n/g, '');
      var poiOptions = this.poiOptions;
      var poiIcon = this.poiIconFormat.replace(/{{category}}/g, point.icon);

      // -- Parse If Statements
      if (ifStatement = /(\{\{if(.*?)\}\}(.*?)\{\{endif\}\})/g.exec(poiInfoboxHTML)) {
        var condition = ifStatement[2].trim();

        if (point[condition]){
          poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], ifStatement[3]);
        } else {
          poiInfoboxHTML = poiInfoboxHTML.replace(ifStatement[1], '');
        }
      }

      // -- Mustache Var Replace
      for (property in point) {
        var expression = new RegExp('({{' + property + '}})', 'g');
        if (poiInfoboxHTML.match(expression)) {
          poiInfoboxHTML = poiInfoboxHTML.replace(expression, point[property]);
        }
      }

      // -- Determine icon file extension. (.png if IE, .svg if not)
      if (navigator.userAgent.indexOf('rv:11') > -1 || navigator.userAgent.indexOf('MSIE') > -1){
        poiIcon += '.png';
      } else {
        poiIcon += '.svg';
      }

      // -- Draw point onto map.
      var poiMarker = new this.googleMap.Marker({
        map: map.instance,
        position: new this.googleMap.LatLng(point.lat, point.lng),
        icon : map.assetPath + poiIcon
      });

      // -- Push marker into array & bind
      this.poiMarkers.push($.extend(poiMarker, {
        category: point.category,
        id: point.id
      }));

      this.bindMarkerOpen(new InfoBox($.extend(poiOptions, {content: poiInfoboxHTML})), poiMarker);
    },

    poiVisibility: function(category, centerOnPoints) {
      var self = this;
      var boundry = new this.googleMap.LatLngBounds();

      // -- Close all InfoBoxes except Main
      if (this.openWindow && !this.openWindow.isMain) {
        this.openWindow.close();
      }

      // -- Hide everything not matching passed-in category
      this.poiMarkers.forEach(function(marker){
        marker.setVisible(false);

        if (marker.category == category) {
          boundry.extend(marker.position);
          marker.setVisible(true);
        }
      });

      if (centerOnPoints && $(window).width() >= 660){
        this.instance.fitBounds(boundry);
        this.instance.setZoom(this.instance.getZoom() - 1);
      } else if ($(window).width() < 660) {
        var centerBoundry = new this.googleMap.LatLngBounds().extend(this.latlng);

        setTimeout(function(){
          self.instance.fitBounds(centerBoundry);
          self.instance.setZoom(self.instance.getZoom() - 7);
        }, 100);
      }
    },

    bindMarkerOpen: function(infoBoxObject, markerObject) {
      var self = this;
      this.bindTogglePoiInfobox(infoBoxObject, markerObject);
      this.googleMap.event.addListener(markerObject, 'click', function(){
        self.openWindow.close();
        self.openMarker(infoBoxObject, markerObject);
      });
    },

    openMarker: function(infoBoxObject, markerObject, callback) {
      // -- Close all InfoBoxes except Main
      if (this.openWindow && !this.openWindow.isMain) {
        this.openWindow.close();
      }

      // -- Open new InfoBox
      var $listingItem = this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']');
      infoBoxObject.open(this.instance, markerObject);
      this.$poiToggleBox.removeClass('neighborhood__poi-category-link--active');
      $listingItem.addClass('neighborhood__poi-category-link--active');
      this.openWindow = infoBoxObject;

      if ($listingItem.parent().data('js-hook') == 'poi-hidden' && !$listingItem.parent().is(':visible')) {
        $('#load-all-poi').trigger('click');
      }
    },

    bindControls: function() {
      var self = this;

      // -- Adjust POI Visibility when selecting a filter
      this.$poiFilter.first().attr('data-selected', true);

      this.$poiFilter.click(function(e){
        e.preventDefault();

        self.currentCategory = $(this).data('poi');
        self.poiVisibility(self.currentCategory, true);
      });

      // -- Map click closes all windows
      this.googleMap.event.addListener(self.instance, 'click', function(){
        self.mainInfoBox.close();
        if (self.openWindow) {
          self.openWindow.close();
        }
      });

      // -- Zoom In Control
      this.$zoomIn.unbind().click(function(e){
        e.preventDefault();
        self.instance.setZoom(self.instance.getZoom() + self.zoomIncrement);
      });

      // -- Zoom Out Control
      this.$zoomOut.unbind().click(function(e){
        e.preventDefault();
        self.instance.setZoom(self.instance.getZoom() - self.zoomIncrement);
      });

      // -- Refresh Control
      this.$refresh.unbind().click(function(e){
        e.preventDefault();
        self.currentCategory = self.defaultCategory;
        self.loadMap();
      });
    },

    bindTogglePoiInfobox: function(infoBoxObject, markerObject) {
      var self = this;
      var togglePoiActiveClass = 'neighborhood__poi-category-link--active';
      this.$poiToggleBox.filter('[data-poi-id=' + markerObject.id + ']').click(function(e){
        e.preventDefault();
        if ($(window).width() >= 808) {
          self.poiVisibility(markerObject.category);
          self.openWindow.close();
          self.openMarker(infoBoxObject, markerObject);
          self.$poiToggleBox.removeClass(self.poiActiveClass);
          $(this).addClass(self.poiActiveClass);
          self.instance.panTo(new self.googleMap.LatLng(markerObject.position.lat(), markerObject.position.lng()));
          $('html, body').stop().animate({
            scrollTop: self.$mapCanvas.offset().top
          }, 300);
        }
      });
    },

    setOptions: function(){
      this.latlng = new google.maps.LatLng(mapSettings.lat, mapSettings.lng);

      // -- Point of Interest Infobox Options Object
      this.poiOptions = {
        content: null, // -- Set by drawPoint
        disableAutoPan: false,
        alignBottom: true,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(0, -30),
        zIndex: null,
        boxClass: "map__infobox",
        infoBoxClearance: new google.maps.Size(1, 1),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: true
      };

      // -- Pinpoint Infobox Options Object
      this.pinpointOptions = {
        content: this.mainInfoboxHTML,
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: new google.maps.Size(-71, -160),
        zIndex: 9999,
        boxStyle: {},
        boxClass: "map__infobox",
        closeBoxMargin: "-20px 43px 0 0",
        closeBoxURL: "",
        infoBoxClearance: new google.maps.Size(1, 1),
        isHidden: false,
        pane: "floatPane",
        enableEventPropagation: true
      };

      // -- Map Options Object
      this.mapOptions = {
        zoom: 14,
        minZoom: 5,
        maxZoom: 25,
        scrollwheel:false,
        center: this.latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        disableDefaultUI: true,
        styles: this.mapStyles
      };
    },

    init: function() {
      if (typeof mapSettings != 'undefined') {
        this.dom();
        this.definitions();
        this.onGoogleLoad(this.loadMap);
      }
    }
  }

  $(function(){ map.init(); });
})();

(function(){

  var neighborhood = {
    a: {
      dom: function() {
        this.$loadAll     = $('#load-all-poi');
        this.$poiList     = $('[data-js-hook="poi-list"]');
        this.$loadLocal   = $('[data-js-hook="load-local-poi"]');
        this.$poi         = $('[data-js-hook="poi-hidden"]');
      },

      loadAll: function() {
        var self = this;

        this.$loadAll.click(function(e){
          e.preventDefault();
          var $this = $(this);

          self.$poi.slideToggle(200, function(){
            $this.text(self.$poi.first().is(':visible') ? 'Load Less' : 'Load All');
          });
        });
      },

      loadLocal: function() {
        var self = this;
        this.$loadLocal.click(function(e){
          e.preventDefault();
          $(this).toggleClass('neighborhood-a__poi-category-header--active');
          self.$poiList.filter('[data-category="' + $(this).data('category') + '"]').slideToggle(200);
        });
      },

      ready: function() {
        this.dom();
        this.loadAll();
        this.loadLocal();
      }
    },

    b: {
      dom: function() {
        this.$loadLocal             = $('[data-js-hook="load-local-poi"]');
        this.$poi                   = $('[data-js-hook="poi-hidden"]');
        this.$poiFilter             = $('[data-js-hook="poi-filter"]');
        this.$categorySelectLink    = $('#category-select-link');
        this.$categorySelectOptions = $('#category-select-options');
        this.$poiCategory           = $('[data-js-hook="poi-category"]');
      },

      data: {
        activePoiFilterClass: 'map-a__cat-link--active'
      },

      loadLocal: function() {
        var self = this;

        this.$loadLocal.click(function(e){
          e.preventDefault();
          var $this = $(this);
          var $poi = self.$poi.filter('[data-category="' + $(this).data('category') + '"]');

          $poi.slideToggle(200, function(){
            $this.find('[data-js-hook="load-text"]').text($poi.first().is(':visible') ? '- Load Less' : '+ Load ALl');
          });
        });
      },

      /*
        Function relies on map.js assigning `data-selected` attribute
        values to category anchors on click.
      */
      injectCategoryHTML: function() {
        var activeCategoryHTML = this.$poiFilter.filter('[data-selected=true]').html();
        if (activeCategoryHTML) {
          this.$categorySelectLink.html(activeCategoryHTML.replace('poi-filter', 'poi-select-toggle'));
        }
      },

      categorySelect: function() {
        var self = this;
        this.$poiFilter.first().attr('data-selected', true);

        // -- Toggle Category Options
        this.$categorySelectLink.click(function(e){
          e.preventDefault();
          self.$categorySelectOptions.slideToggle(100);
        });

        // -- Category Selection
        this.$poiFilter.click(function(e){
          self.$poiFilter.attr('data-selected', false).removeClass(self.data.activePoiFilterClass);
          $(this).attr('data-selected', true).addClass(self.data.activePoiFilterClass);
          self.injectCategoryHTML();
          self.$categorySelectLink.trigger('click');
          self.$poiCategory.hide().filter('[data-category="' + $(this).data('poi') + '"]').show();
        });
      },

      ready: function() {
        this.dom();
        this.loadLocal();
        this.categorySelect();
        this.injectCategoryHTML();
      }
    },

    ready: function() {
      switch (parseInt(neighborhoodSettings.layout)) {
        case 1:
          this.a.ready();
          break;
        case 2:
        case 3:
          this.b.ready();
          break;
      }
    }
  }

  $(function(){
    if (typeof neighborhoodSettings != 'undefined') {
      neighborhood.ready();
    }
  });
})();

(function($){
  'use strict';

  var news = {
    setHeight: function() {
      if ($(window).width() > 808) {
        var setHeight = 0;
        $('.article__item').each(function(){
          $(this).height('auto');
          if ($(this).height() > setHeight) {
            setHeight = $(this).height();
          }
        });
        $('.article__item').each(function(){
          $(this).height(setHeight);
        });
      } else {
        $('.article__item').each(function(){
          $(this).height('auto');
        });
      }
    }
  };

  $(window).on('load resize', function() {
    if (!Modernizr.flexbox) {
      news.setHeight();
    }
  });

})(jQuery);

(function($) {
  'use strict';

  var calculator = {
    dom: function() {
      this.$calculator = $('#calculator');
    },

    calculator: function() {
      var main = this;
      $('input[type=text]', main.$calculator).on('keyup', function() {
        $('[data-sum]').each(function() {
          var cellTotal = 0;
          var cell = $(this).data('sum');
          $('[data-cell="' + cell + '"]').each(function(index, element) {
            if ($(element).val().length) {
              cellTotal += parseInt($(element).val());
            }
          });
          $(this).val(cellTotal);
          $('[data-math="' + cell + '"]').val(cellTotal - $('[data-minus="' + cell + '"]').val());
        });
      });
      $('[data-minus]', main.$calculator).on('keyup', function() {
        var cell = $(this).data('minus');
        $('[data-math="' + cell + '"]').val($('[data-sum="' + cell + '"]').val() - $(this).val());
      });
    },

    ready: function() {
      if ($('#calculator').length) {
        this.dom();
        this.calculator();
      }
    }
  };

  $(document).ready(calculator.ready());

})(jQuery);


if ($('.expand-label').length) {
  $('.expand-label').click(function(e) {
    e.preventDefault();
    $(this).data('open', !$(this).data('open'));
    $(this).next().slideToggle(200);
    if ($(this).data('open')) {
      $(this).addClass('open');
    } else {
      $(this).removeClass('open');
    }
  });
}

$(document).ready(function() {
  setupShareThis();
});

function setupShareThis(){
  var shareContainer = $('#share-this-popup');
  var shareLink = $('#share-link');
  var shareLoader = $('#share-loader');
  var activeClass = 'share-this-popup--show';

  shareContainer.data('loaded', '0');

  shareLink.on('click',function(e){
    e.preventDefault();
    e.stopPropagation();

    //If we don't have any Share This content on the page already, fetch it via AJAX
    if (shareContainer.data('loaded') == '0') {
      //indicate that it's loading...
      shareLoader.show();
      shareLink.hide();

      //mark Share This as loaded so we won't load it via AJAX again unless page is refreshed
      shareContainer.data('loaded', '1');

      //If user overrode defaults in the HTML markup, use the override values here
      var sUrl = shareContainer.data('url') || '';
      var sTweetFilter = shareContainer.data('tweet-filter') || 'GLOBAL';
      var sEmailFilter = shareContainer.data('email-filter') || 'GLOBAL';
      var iPropertyID = shareContainer.data('property') || '';

      //fetch the Share This content via AJAX
      shareContainer.load(shareContainer.data('script'), { 'url': sUrl, 'email_filter': sEmailFilter, 'tweet_filter': sTweetFilter, 'property': iPropertyID }, function() {
        shareContainer.addClass(activeClass);
        //remove the loading indicator
        shareLoader.hide();
        shareLink.show();
      });
    }
    else {
      //We've already fetched Share This content for this page, so just show it
      shareContainer.toggleClass(activeClass);
    }
  });

  $('body').click(function() {
    //if the "SHARE" tooltip is visible, then close it
    if (shareContainer.hasClass(activeClass)) {
      shareContainer.toggleClass(activeClass);
    }
  });
}

(function(){
  var skipStep = {
    domCache: function() {
      this.leaseObject  = {};
      this.picker       = null;
      this.$bindEl      = null;
      this.$confirm     = null;
      this.$table       = $('[data-js-hook="panel"]').filter('[data-type="check-availability"]');
      this.$unitSelect  = $('[data-js-hook="lease-now"]');
      this.$leaseButton = $('[data-js-hook="lease-button"]');
      this.$leaseTerm   = $('[data-js-hook="lease-term-input"]');
    },

    injectBindElement: function(callback) {
      var self = this;
      var bindEl = document.createElement('div');
      bindEl.id = 'picker-bind';
      self.$bindEl = $(bindEl);
      $('body').prepend(self.$bindEl);
    },

    bindUnitSelect: function() {
      var self = this;

      // -- Re-build leaseObject on change
      this.$unitSelect.click(function(e){
        e.preventDefault();
        e.stopPropagation();
        var lease_term = null;

        if ($(this).data('lease-term')) {
          lease_term = self.$leaseTerm.filter('[data-unit="' + $(this).data('unit') + '"]:checked').val();
        }

        self.leaseObject.unit        = $(this).data('unit');
        self.leaseObject.building    = $(this).data('building');
        self.leaseObject.id          = $(this).data('id-value');
        self.leaseObject.start       = $(this).data('availability-start');
        self.leaseObject.end         = $(this).data('availability-end');
        self.leaseObject.url         = decodeURI($(this).attr('href'));
        self.leaseObject.date_format = $(this).data('date-format') || 'mm-dd-yyyy';
        self.leaseObject.lease_term  = lease_term;
        self.leaseObject.pic         = $(this).data('pic');
        self.leaseObject.yss         = $(this).data('yss');

        self.openPickerInstance();
      });
    },

    confirmUrlInject: function() {
      if (this.$confirm) {
        this.$confirm.attr('href', this.leaseObject.url.replace('{lease_term}', this.leaseObject.lease_term).replace('{unit_id}', this.leaseObject.id).replace('{unit}', this.leaseObject.unit).replace('{date}', this.picker.get('highlight', this.leaseObject.date_format)));
      }
    },

    pickadateInit: function() {
      this.picker = this.$bindEl.pickadate({
        closeOnSelect: false
      }).data('pickadate').stop();
    },

    pickadateHTMLInject: function() {
      // -- Custom Header Markup
      var customHeader = '<h1 id="custom-picker-header" class="picker__custom-header">\
                            Desired Move-in Date\
                          </h1>';

      // -- Custom Confirm Markup
      var customConfirm = '<div id="custom-picker-confirm" class="picker__confirm-wrap">\
                            <a target="_blank" id="picker-confirm" class="picker__confirm" href="#">\
                              Lease Now\
                            </a>\
                           </div>';

      // -- Remove custom markup before re-injection
      $('#custom-picker-header').remove();
      $('#custom-picker-confirm').remove();

      // -- Inject (or re-inject)
      $('.picker__frame').prepend(customHeader).append(customConfirm);

      // -- Bind (or re-bind) confirm button
      this.$confirm = $('#picker-confirm');
      this.bindConfirmButton();
    },

    bindConfirmButton: function($el) {
      var self = this;
      if (this.$confirm) {
        this.$confirm.unbind().bind('click', function(){
          if (self.picker) {
            self.picker.close();
          }
        });
      }
    },

    // -- Bind pop-calendar click event to open Pickadate
    openPickerInstance: function() {
      var self = this;

      // -- Retrieve & format selected unit's availability start & end date
      if (self.leaseObject.start && self.leaseObject.end) {
        var start = self.leaseObject.start.split('-');
        var end = self.leaseObject.end.split('-');
        start = start.map(function(num){return parseInt(num)});
        end = end.map(function(num){return parseInt(num)});
        // -- Re-adjust Month for JS Date Format
        start[1] = parseInt(start[1]) - 1;
        end[1] = parseInt(end[1]) - 1;
      }

      // -- Destroy and rebuild Picker w/ new start & end
      self.picker
        .stop()
        .start()
        .set('disable', [ { from: start, to: end } ])
        .set('disable', 'flip')
        .set('select', start)
        .on({
          open: function(){
            self.pickadateHTMLInject();
            self.confirmUrlInject();
          },
          set: function() {
            self.confirmUrlInject();
          },
          close: function() {
            self.picker.stop();
          }
        })
        .open();
    },

    // -- skipStep object kickoff
    init: function() {
      this.domCache();

      if (parseInt(this.$table.data('skip-step-init'))) {
        this.injectBindElement();
        this.bindUnitSelect();
        this.pickadateInit();
      }
    }
  };

  $(function(){
    skipStep.init();
  });
})();

(function($) {
  'use strict';

	var whatWeDo = {
		domCache: function() {
			this.$expandDesc = $('[data-js-hook="expand-desc"]');
		},

		expandDesc: function() {
			this.$expandDesc.on('click', function(e){
				e.preventDefault();
				$('#expand-desc_' + $(this).attr('data-id')).toggle();
		    $(this).text($(this).text() === '. . . Read More' ? '. . . Less' : '. . . Read More');
			});
		},

		init: function() {
			this.domCache();
			this.expandDesc();
		}
	};

	$(document).ready(whatWeDo.init());
})(jQuery);

//# sourceMappingURL=custom.js.map
